module.exports = __webpack_public_path__ + "img/loyalty-card.a557daa1.png";